import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cached = null;
let listeners = [];

export function useSiteInfo() {
  const [info, setInfo] = useState(cached);

  useEffect(() => {
    if (cached) {
      setInfo(cached);
      return;
    }
    api.get("/site-info").then((r) => {
      cached = r.data;
      setInfo(cached);
      listeners.forEach((l) => l(cached));
    });
    const cb = (v) => setInfo(v);
    listeners.push(cb);
    return () => {
      listeners = listeners.filter((l) => l !== cb);
    };
  }, []);

  return info;
}

export function isComingSoon(info) {
  return info?.mode === "coming_soon";
}
